
// 不可放单，可放单，已放单
import Model from '../utils/Model'

export class ReleaseState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const NOTSINGLERELEASE = new ReleaseState(0, 'Not Released', '待审核')
export const BUCKLERELEASE = new ReleaseState(10, 'B/L Seized', '已扣单')
export const SINGLERELEASE = new ReleaseState(1, 'B/L Releaseable', '可放单')

export const ONSINGLERELEASE = new ReleaseState(2, 'Released', '已放单')
export const APPLICATIONED = new ReleaseState(3, 'Applicationed', '已申请')
export const TO_BE_COLLECTED = new ReleaseState(4, 'Pending Collection', '待收款')

export const RELEASE_STATE = new Set([NOTSINGLERELEASE, BUCKLERELEASE, SINGLERELEASE, APPLICATIONED, ONSINGLERELEASE, TO_BE_COLLECTED])

export const RELEASE_STATE_SEARCH = new Set([NOTSINGLERELEASE, BUCKLERELEASE, SINGLERELEASE, ONSINGLERELEASE, TO_BE_COLLECTED])

/**
 *  return null:没找到.
 */
export function getReleaseStateByCode(code) {
  return Model.getObjByCode(code, RELEASE_STATE)
}

/**
 * 获取名称
 */
export function getCargoDocCfmStateByName(code, field) {
  if (field === null || field === '') field = 'chineseName'
  const releaseState = Model.getObjByCode(code, RELEASE_STATE)
  return releaseState ? releaseState[field] : ''
}
